import React from "react";
import { Route } from "react-router-dom";
import EditProfile from "./EditProfile";
import ProfileSideBar from "./ProfileSidebar";
import SigninInfo from "./SigninInfo";
import Wallet from "../wallet/Wallet";
import styles from "./profile.module.scss";

const Profile = () => {
  return (
    <div className="main container mx-auto mt-24 flex-grow">
      <div className="flex gap-20">
        <ProfileSideBar />
        <div className="grow">
          <Route path="/profile/wallet">
            <Wallet />
          </Route>
          <Route path="/profile" exact={true}>
            <EditProfile />
          </Route>
          <Route path="/profile/signin-info">
            <SigninInfo />
          </Route>
        </div>
      </div>
    </div>
  );
};

export default Profile;
